<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <h1 class="title">{{ 'SEUTULIPPU' | translate }}</h1>
            <p class="description margin-bottom-60">{{ 'SEUTULIPPU_DESCRIPTION' | translate }}</p>

            <div class="card-list-table__travel-card-title">
                <span>{{ 'MY_SEUTULIPPU' | translate }}</span>
            </div>
            <div class="card-list-table__travel-card"></div>

            <div class="action-empty-state">
                <p class="empty-card-detail-view-area-ticket__description">
                    {{ 'SEUTULIPPU_EMPTY_STATE_DESCRIPTION' | translate }}
                </p>
                <button class="btn btn--primary" [routerLink]="'/account/seutulippu/register' | localize">
                    {{ 'REGISTER_SEUTULIPPU' | translate }}
                </button>
            </div>
        </div>
    </ridango-page-content-wrapper>
</div>
